module.exports = __webpack_public_path__ + "static/project-16f-7cd414e1178bcada1a0d869fcdc6a337.png";